import { render, staticRenderFns } from "./GeneralScore.vue?vue&type=template&id=16368c14&"
import script from "./GeneralScore.vue?vue&type=script&lang=js&"
export * from "./GeneralScore.vue?vue&type=script&lang=js&"
import style0 from "./GeneralScore.vue?vue&type=style&index=0&id=16368c14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports